import React, {  useState } from "react";
import MainBanner from "../../../Components/MainBanner";
import AskSection from "../../../Components/AskSection";
import BenefitsSection from "../../../Components/BenefitsSection";
import HelpSteps from "../../../Components/HelpSteps";
import BonusSection from "../../../Components/BonusSection";
import StudentStories from "../../../Components/StudentStories";
import ChatHelpExperts from "../../../Components/ChatHelpExperts";
import CommonForm from "../../HomePage/Form/CommonForm";
import ScrollTop from "../../../Components/Buttons/ScrollTop";
import AssignmentList from "../../../Components/AssignmentList";
import Universities from "../../../Components/Universities";
import Milestonerewards from "../../../Components/Milestonerewards";
import Page from "../../Metadata/Page";
import ComWorldWide from "../../../Components/ComWorldWide";
import ComReadMoreSection from "../../../Components/ComReadMoreSection";
import BreadCrumb from "../../../Components/BreadCrumb/BreadCrumb";

const PresentationWriting = () => {
  const subCategoryId = "6586d98fdafb1f4a8f46126f";
  const categoryId = "65524e633c005ef3b51907c9";
  const [isModelOpen, setIsModelOpen] = useState(false);
  const toggle = () => {
    setIsModelOpen(!isModelOpen);
  };

  const breadCrumbData = [
    { label: "Home", path: "/" },
    { label: "Assignment Help" },
    { label: "Do My Presentation" },
  ];
  return (
    <>
      <Page subCategoryId={subCategoryId} categoryId={categoryId} />

      <div className="container">
        <div className="row mt-2 mb-2 m-0">
          <BreadCrumb items={breadCrumbData} />
        </div>
      </div>

      <MainBanner id={subCategoryId} setIsModelOpen={setIsModelOpen} />
      <AskSection />
      <BenefitsSection
        subCategoryId={subCategoryId}
        setIsModelOpen={setIsModelOpen}
        title="Benefits of DoubtQ Presentation Writing Services"
        description="Designed to deliver quality, accuracy, and convenience for every student"
      />
      <AssignmentList
        subCategoryId={subCategoryId}
        setIsModelOpen={setIsModelOpen}
        title="Recently Completed Presentation Writing Samples"
        description="Explore high-quality Presentation samples completed by experts for students"
      />
      <HelpSteps
        subCategoryId={subCategoryId}
        description="Get your Presentation Writing support in 4 easy steps"
        // stepsData={pageData?.helpStepData && pageData?.helpStepData[0]}
      />
      <Milestonerewards
        categoryId={categoryId}
        description="Designed to deliver quality, accuracy, and convenience for every studen"
      />
      <BonusSection
        subCategoryId={subCategoryId}
        setIsModelOpen={setIsModelOpen}
      />
      <Universities categoryId={categoryId} setIsModelOpen={setIsModelOpen} />
      <StudentStories />
      <ChatHelpExperts
        title="Meet our Presentation Writing Experts"
        description="Our professionals deliver high-quality presentations with an improved writing experience"
      />
      <ComWorldWide id={subCategoryId} />
      <ComReadMoreSection id={subCategoryId} />
      {isModelOpen ? (
        <CommonForm
          isOpen={isModelOpen}
          toggle={toggle}
          typeData={{
            serviceType: "AssignmentHelp",
            type: "assignmentHelp",
            totalSteps: 1,
          }}
          subCategory={subCategoryId}
        />
      ) : (
        <></>
      )}
      <ScrollTop />
    </>
  );
};

export default PresentationWriting;
